<template>
  <div>
    <b-container class="contact">
      <b-row>
        <b-col sm="6">
          <b-row>
            <b-col sm="12">
              <h2 class="styled-title" style="margin-bottom: 30px">
                {{ contactDetail }}
              </h2>
            </b-col>
          </b-row>
          <div class="mb">
            <validation-observer ref="observer">
              <b-form ref="subscribeForm" @submit.prevent="sendMessage()">
                <validation-provider
                  name="Name"
                  :rules="{ required: true, min: 3 }"
                  v-slot="validationContext"
                >
                  <b-form-group id="name" label="Name *" label-for="name">
                    <b-form-input
                      id="name"
                      name="name"
                      v-model="name"
                      :state="getValidationState(validationContext)"
                      aria-describedby="name-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="name-live-feedback">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  name="Email"
                  :rules="{ required: true, email: true, min: 3 }"
                  v-slot="validationContext"
                >
                  <b-form-group
                    id="email"
                    label="Email Address *"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      name="Email"
                      v-model="email"
                      :state="getValidationState(validationContext)"
                      aria-describedby="email-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="email-live-feedback">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  name="Subject"
                  :rules="{ required: true, min: 3 }"
                  v-slot="validationContext"
                >
                  <b-form-group
                    id="Subject"
                    label="Subject *"
                    label-for="subject"
                  >
                    <b-form-input
                      id="Subject"
                      name="Subject"
                      v-model="subject"
                      :state="getValidationState(validationContext)"
                      aria-describedby="subject-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="subject-live-feedback">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  name="Message"
                  :rules="{ required: true, min: 20 }"
                  v-slot="validationContext"
                >
                  <b-form-group
                    id="Message"
                    label="Message *"
                    label-for="Message"
                  >
                    <b-form-textarea
                      id="Message"
                      placeholder="Tell us how you feel"
                      rows="7"
                      v-model="message"
                      :state="getValidationState(validationContext)"
                      aria-describedby="message-live-feedback"
                    ></b-form-textarea>

                    <b-form-invalid-feedback id="message-live-feedback">{{
                      validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-form>
            </validation-observer>
          </div>

          <b-row>
            <b-col sm="12" class="pull-right">
              <b-button
                :disabled="processing"
                variant="primary"
                @click="sendMessage()"
              >
                <b-icon
                  v-if="processing"
                  class="primary-color"
                  icon="soundwave"
                ></b-icon>
                <b-icon v-else icon="box-arrow-right" font-scale="1"></b-icon>
                {{ processing ? processingTitle : subscribeButton }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="6">
          <b-row>
            <b-col sm="12">
              <h2 class="styled-title" style="margin-bottom: 30px">
                {{ mapLocation }}
              </h2>
            </b-col>
          </b-row>
          <div v-for="item in data" :key="item.id" style="margin-bottom: 40px">
            <b-row>
              <b-col sm="12">
                <b-icon
                  icon="house"
                  font-scale="1.3"
                  variant="primary"
                ></b-icon>
                <span class="ml">
                  {{ item.title }}
                </span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
              <b-col sm="12">
                <b-icon icon="map" font-scale="1.3" variant="primary"></b-icon>
                <span class="ml">
                  {{ item.address }}
                </span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
              <b-col sm="6">
                <b-icon
                  icon="phone"
                  font-scale="1.3"
                  variant="primary"
                ></b-icon>
                <span class="ml">
                  <a href="`tel:` + item.phoneNumberUrl">
                    {{ item.phoneNumber }}
                  </a>
                </span>
              </b-col>
              <b-col sm="6">
                <b-icon
                  icon="envelope"
                  font-scale="1.3"
                  variant="primary"
                ></b-icon>
                <span class="ml">
                  <a href="`mailto:` + item.email">
                    {{ item.email }}
                  </a>
                </span>
              </b-col>
            </b-row>
          </div>
          <GmapMap
            :center="locations"
            :zoom="17"
            map-type-id="terrain"
            style="width: 100%; height: 400px"
          >
          </GmapMap>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      drawer: true,
      contactDetail: "Leave Us a Message",
      mapLocation: "Contact Information",
      locations: { lat: 6.436033, lng: 3.428428 },
      data: [],
      email: null,
      name: null,
      subject: null,
      message: null,
      status: "Not Contacted",
      subscribeButton: "SEND MESSAGE",
      processingText: "SENDING",
      processing: false,
      processingTitle: "SENDING...",
      res: "1023",
      note:
        "Kindly fill the form below to let us kow how we can serve you better. We love feedbacks."
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    sendMessage() {
      if (
        this.name != null &&
        this.email != null &&
        this.subject != null &&
        this.message != null
      ) {
        this.processing = true;
        db.collection("contactUsMessage")
          .add({
            name: this.name,
            email: this.email,
            subject: this.subject,
            message: this.message,
            status: this.status
          })
          .then(result => {
            this.res = result;
            this.processing = false;
            // Trick to reset/clear native browser form validation state
            this.$bvToast.toast(
              `You message has been sent successfully, we will act on this as soon as possible.`,
              {
                title: "Message Successfuly Sent",
                autoHideDelay: 7500,
                variant: "success",
                toaster: "b-toaster-bottom-full"
              }
            );
            this.$refs.subscribeForm.reset();
          })
          .catch(error => {
            this.processing = false;
            this.$bvToast.toast(error, {
              title: "Sending Failed",
              autoHideDelay: 5000,
              variant: "error",
              toaster: "b-toaster-bottom-full"
            });
          });
      } else {
        this.$bvToast.toast(
          `Kindly provide all required fields. Fields marked as * are required`,
          {
            title: "Subscription Failed",
            autoHideDelay: 5000,
            variant: "warning",
            toaster: "b-toaster-bottom-full"
          }
        );
      }
    }
  },
  firestore: {
    data: db.collection("contactUs").orderBy("sortId")
  }
};
</script>

<style lang="scss" scoped>
.contact a {
  color: #333333;
}
.contact a:hover {
  color: #7a7676 !important;
}
.contact-form {
  padding: 20px 40px;
  background: #ffffff;
}
.cntnt {
  padding: 48px 80px 2px 80px;
}
.ml {
  margin-left: 10px;
  font-size: 20px;
}
.mv {
  margin: 80px 0;
}
.team {
  margin: 80px 0;
}

.team-grid {
  text-align: center;
}
.col-xs-4 {
  width: 33.33333333%;
  float: left;
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
/*-- Team --*/

.team {
  background: #f5f5f5;
  padding: 1em 0;
}

.team-grid {
  text-align: center;
}

.team-grid h4 {
  // font-family: "Red Rose", cursive;
  font-size: 30px;
  color: #363636;
  font-weight: 600;
  margin: 40px 0 20px;
}

.team-grid p {
  color: #636363;
  font-size: 20px;
  margin-top: -20px;
}

.model-3d-0 a {
  background: #5c5b5b;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  -o-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.model-3d-0 .front,
.model-3d-0 .back {
  width: 30px;
  height: 30px;
  font-size: 1em;
  color: #fff;
  background: #faad81;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transform: translateZ(18px);
  -moz-transform: translateZ(18px);
  -ms-transform: translateZ(18px);
  -o-transform: translateZ(18px);
  transform: translateZ(18px);
  -webkit-backface-visibility: visible;
  -moz-backface-visibility: visible;
  -ms-backface-visibility: visible;
  -o-backface-visibility: visible;
  backface-visibility: visible;
}

.model-3d-0 .back {
  font-size: 1em;
  color: #fff;
  -webkit-transform: rotateX(90deg) translateZ(18px);
  -moz-transform: rotateX(90deg) translateZ(18px);
  -ms-transform: rotateX(90deg) translateZ(18px);
  -o-transform: rotateX(90deg) translateZ(18px);
  transform: rotateX(90deg) translateZ(18px);
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
}

.model-3d-0 a:hover {
  -webkit-transform: rotateX(-90deg);
  -moz-transform: rotateX(-90deg);
  -ms-transform: rotateX(-90deg);
  -o-transform: rotateX(-90deg);
  transform: rotateX(-90deg);
}

.model-3d-0 a:hover .back {
  -webkit-backface-visibility: visible;
  -moz-backface-visibility: visible;
  -ms-backface-visibility: visible;
  -o-backface-visibility: visible;
  backface-visibility: visible;
}

.stack img {
  width: auto;
  height: 520px;
  vertical-align: bottom;
  border: 10px solid #fff;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -o-border-radius: 3px;
  -ms-border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -o-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -ms-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}

.stack:last-of-type {
  margin-right: 0;
}

/* Third stack example (One stack element rotated in the opposite direction) */

.stack.twisted:before {
  -webkit-transform: rotate(4deg);
  -moz-transform: rotate(4deg);
  transform: rotate(4deg);
  -moz-transform: rotate(4deg);
  -o-transform: rotate(4deg);
}

.stack.twisted:after {
  -webkit-transform: rotate(-4deg);
  -moz-transform: rotate(-4deg);
  transform: rotate(-4deg);
  -ms-transform: rotate(-4deg);
  -o-transform: rotate(-4deg);
}

/* Reset all rotations on hover */

.stack:hover:before,
.stack:hover:after,
.team-grid:hover .stack:before,
.team-grid:hover .stack:after {
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  transform: rotate(0deg);
  -o-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
}

/* Stacks creted by the use of generated content */

.stack:before,
.stack:after {
  content: "";
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -o-border-radius: 3px;
  -ms-border-radius: 3px;
  -moz-border-radius: 3px;
  width: 100%;
  height: 100%;
  position: absolute;
  border: 10px solid #fff;
  left: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -ms-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -o-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  -webkit-transition: 0.3s all ease-out;
  -moz-transition: 0.3s all ease-out;
  transition: 0.3s all ease-out;
  -o-transition: 0.3s all ease-out;
  -ms-transition: 0.3s all ease-out;
}

.stack:before {
  top: 4px;
  z-index: -10;
}

/* 1st element in stack (behind image) */

.stack:after {
  top: 8px;
  z-index: -20;
}

/* 2nd element in stack (behind image) */

.stack {
  float: none;
  width: 92%;
  margin: 3% 0% 8% 4%;
  position: relative;
  z-index: 1;
}

.card {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: -1px 2px 4px rgba(0, 0, 0, 0.25), 1px 1px 3px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  max-width: 340px;
}

.card-media {
  width: 100%;
}

.card-details {
  padding: 5px 15px;
}

.card-head {
  font-weight: 400;
}

.card-head {
  font-size: 26px;
  margin-bottom: 15px;
}

.card-action-button {
  border-radius: 2px;
  color: #ffab40;
  cursor: pointer;
  display: inline-block;
  font-weight: 500;
  margin: 0;
  padding: 10px;
  text-decoration: none;
}

.card-action-button:hover {
  background-color: rgba(255, 168, 58, 0.2);
}
.icmspic {
  padding: 120px 0 0 0;
  height: 100%;
}
.icmsinfo {
  padding: 40px 40px 0 40px;
  // width: 95%;
}
.icmsinfo .midtext {
  font-family: "Red Rose", cursive;
  font-size: 30px;
  color: #323232;
  line-height: 42px;
  margin: 0 0 12px 0;
}
.icmsinfo .bigtext {
  font-family: "Red Rose", cursive;
  font-size: 40px;
  color: #af0000;
  line-height: 50px;
  margin: 0 0 20px 0;
}
.icmsinfo .smalltext {
  font-size: 20px;
  line-height: 24px;
  color: #323232;
  width: 95%;
}
.companyglance {
  margin: 50px 0 0 0;
}
.compglancetxt {
  font-size: 30px;
  color: #323232;
  font-family: "Red Rose", cursive;
}
.glancegroup {
  margin: 30px 0 0 0;
}
.glanceitem {
  display: inline-block;
  vertical-align: top;
  margin: 0 42px 0 0;
  padding: 0 42px 0 0;
  border-right: 1px solid #b0bec5;
}
.glancenumber {
  color: #af0000;
  font-size: 48px;
  font-family: "Red Rose", cursive;
}
.glancetxt {
  font-size: 14px;
  font-family: "Red Rose", cursive;
  text-transform: uppercase;
  color: #263238;
}
.glanceitem:last-child {
  border-right: 0;
  padding: 0;
  margin: 0;
}
</style>
